var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"h100p",attrs:{"id":"app-wrapper"}},[_c('el-header',[_c('top-header',{ref:"topHeader"})],1),_c('el-main',{staticClass:"main-content"},[_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('keep-alive',[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }